import './App.css'
import Navbar from './components/Navbar';
import TextBox from './components/TextBox';
function App() {
  return (

  <>
    
  <Navbar title="Text-utils"/>
  <div className="container my-3">
    

    <TextBox heading="Enter The text to analyase"/>
  </div>


  


  </>
    
  );
}

export default App;
